import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CalendarTimeIndicatorLines } from '../types';

export const stripeBackgroundStyle = css({
  background: `repeating-linear-gradient(135deg,
  ${theme.colors.neutral5} 0px,
  ${theme.colors.neutral5} 0.6rem,
  ${theme.colors.neutral10} 0.6rem,
  ${theme.colors.neutral10} 0.9rem) 0px 0px repeat fixed`,
});

const hourLinesBackgroundStyle = css({
  borderWidth: '1px 0',
  borderStyle: 'solid',
  borderColor: theme.colors.neutral20,
  backgroundImage: `repeating-linear-gradient(
      to bottom,
      transparent,
      transparent calc(var(--resolved-row-height) * 60 - 1px),
      rgba(0, 0, 0, 0.1) calc(var(--resolved-row-height) * 60 - 1px),
      rgba(0, 0, 0, 0.1) calc(var(--resolved-row-height) * 60)
    )`,
});

const halfHourLinesBackgroundStyle = css({
  borderWidth: '1px 0',
  borderStyle: 'solid',
  borderColor: theme.colors.neutral20,
  backgroundImage: `repeating-linear-gradient(
    to bottom,
    transparent,
    transparent calc(var(--resolved-row-height) * 30 - 1px),

    /* Half-hour line (light) */
    rgba(0, 0, 0, 0.05) calc(var(--resolved-row-height) * 30 - 1px),
    rgba(0, 0, 0, 0.05) calc(var(--resolved-row-height) * 30),

    transparent calc(var(--resolved-row-height) * 30 - 1px),
    transparent calc(var(--resolved-row-height) * 60 - 1px),

    /* Full-hour line (darker) */
    rgba(0, 0, 0, 0.12) calc(var(--resolved-row-height) * 60 - 1px),
    rgba(0, 0, 0, 0.12) calc(var(--resolved-row-height) * 60)
  )`,
});

export const getHourLineBackgroundStyle = (timeIndicatorLines: CalendarTimeIndicatorLines) => {
  switch (timeIndicatorLines) {
    case 'half-hourly':
      return halfHourLinesBackgroundStyle;
    case 'hourly':
      return hourLinesBackgroundStyle;
    default:
      return undefined;
  }
};

export const selectedEventStyle = css({
  outline: `2px solid ${theme.colors.primary50}`,
  outlineOffset: 2,
});

export const listItemSideSeparatorStyle = css({
  borderInlineWidth: '0 1px',
  borderInlineStyle: 'solid',
  borderInlineColor: theme.colors.neutral10,
});
